import { useProductNameAndUrl } from 'pages/trading/queryHooks';
import * as TopList from 'components/Layout/Tiles/ListContainer';

export interface ProductTopListNameCellProps {
  productNumber: string;
  clickable?: boolean;
}

export function ProductTopListNameCell({ productNumber }: ProductTopListNameCellProps) {
  const { data: nameAndUrl } = useProductNameAndUrl(productNumber);

  return (
    <TopList.NameCell
      hideColorBar
      name={nameAndUrl?.name ?? productNumber}
      imgSrc={nameAndUrl?.url}
      imageClassName="w-12 h-12 object-cover"
    />
  );
}
